export default __webpack_public_path__ + "static/media/hero-three-bg-481f9e8a.2b9f0ec2.png";